import { apiRequest } from '~/shared-kernel/infrastructure/http/api-client'
import type { PublicPreregistrationRepository } from '~/modules/public/preregistration/application/preregistration.use-cases'
import type { PreregistrationRegistrationOptions } from '~/shared-kernel/domain/preregistration'
export const publicPreregistrationRepository: PublicPreregistrationRepository =
  {
    get: (publicSlug, background = false) =>
      apiRequest(
        'GET',
        '/public/events/{publicSlug}/preregistration',
        { params: { path: { publicSlug } } },
        {
          realm: 'customer',
          ...(background ? { interfaceLoad: 'background' as const } : {})
        }
      ),
    cities: (search) =>
      apiRequest(
        'GET',
        '/public/preregistration/cities',
        { params: { query: { search } } },
        { interfaceLoad: 'background' }
      ),
    submit: (publicSlug, body) =>
      apiRequest(
        'POST',
        '/public/events/{publicSlug}/preregistration',
        { params: { path: { publicSlug } }, body },
        { realm: 'customer' }
      ),
    registrationOptions: () =>
      apiRequest<PreregistrationRegistrationOptions>(
        'GET',
        '/auth/customer/registration/form-options'
      )
  }
